import React, { useEffect, useState, useRef } from "react";

//import scss
import "./Mid-Section-Pc.scss";

//import components
import TenantTable from "./TenantTable.jsx";
import DropdownSelect from "../../../assets/reusableComponents/dropDownSelect";
import CreateExpenseModal from "./CreateExpendeModal.jsx";
import { ToastContainer, toast, Zoom, Bounce } from "react-toastify";
import customToasts from "../../../assets/reusableComponents/myToasts";

//import icons
import { FaAngleDown } from "react-icons/fa";
import { ReactComponent as CalenderIcon } from "../../../assets/icons/custom-calender-icon.svg";
import { ReactComponent as CalenderIconWhite } from "./custom-calender-icon.svg";
import { IoMdAdd } from "react-icons/io";

//redux imports
import { useSelector, useDispatch } from "react-redux";
import { getAllExpensesFromDate } from "../../../../redux/slices/sliceActions";


const MidSectionExpensesPc = () => {
  // redux methods
  const dispatch = useDispatch();
  const { expenses, properties } = useSelector((state) => state.landlordslice);

  const [hovered, setHovered] = useState(false);
  const [hoveredSecond, setHoveredSecond] = useState(false);

  //modal variables
  const [showModal, setShowModal] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastType, setToastType] = useState("success");
  useEffect(() => {
    if (showToast) {
      console.log("im hit");
      if (toastType === "success") {
        customToasts.success("Expense created successfully");
      } else if (toastType === "warning") {
        customToasts.warning("Please fill in all fields");
      } else {
        customToasts.error("Error creating expense");
      }
    }
  }, [showToast]); // Watch showToast instead of showModal

  //date variables
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "long" });
    const year = date.getFullYear();

    const daySuffix = (day) => {
      if (day > 3 && day < 21) return "th";
      switch (day % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    };

    return `${day}${daySuffix(day)} ${month} ${year}`;
  };
  const getCurrentDate = () => {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  //start date variables
  const [startDate, setStartDate] = useState(getCurrentDate());
  const startDateRef = useRef(null);

  //end date variables
  const [endDate, setEndDate] = useState(getCurrentDate());
  const endDateRef = useRef(null);

  // apartment  variables
  const [propertyChoices, setPropertyChoices] = useState([]);
  const [selectedProperty, setSelectedProperty] = useState("Select Apartment");
  useEffect(() => {
    if (Object.keys(properties).length > 0) {
      setPropertyChoices([...properties.map((property) => property.name)]);
    }
  }, [properties]);

  const [houseChoices, setHouseChoices] = useState([" Select House"]);
  useEffect(() => {
    if (selectedProperty !== "Select Apartment") {
      const selectedPropertyObj = properties.find(
        (property) => property.name === selectedProperty
      );
      if (selectedPropertyObj) {
        setHouseChoices(
          selectedPropertyObj.houses.map((house) => house.house_no)
        );
        // setSelectedHouse(selectedPropertyObj.houses[0]?.house_no || "");
      }
    }
  }, [selectedProperty, properties]);

  const [selectedHouse, setSelectedHouse] = useState(houseChoices[0]);

  //expense variables
  const [expenseTypeChoices, setExpenseTypeChoices] = useState([
    "Plumbing",
    "Electricity",
    "Painting",
    "Sewer",
    "Water",
    "Others",
  ]);
  const [selectedExpenseType, setSelectedExpenseType] = useState(
    expenseTypeChoices[0]
  );

  //fetch expenses
  useEffect(() => {
    //check if any of the values are missing
    if (startDate && endDate && selectedProperty && selectedExpenseType) {
      //find the property id
      const selectedPropertyObj = properties.find(
        (property) => property.name === selectedProperty
      );

      dispatch(
        getAllExpensesFromDate({
          property_id: selectedPropertyObj?._id,
          dateFrom: startDate,
          dateTo: endDate,
        })
      ).then((response) => {
        console.log("responses", response);
      });
    }
  }, [startDate, endDate, selectedProperty, selectedExpenseType]);

  return (
    <div className="mid-section-expenses-pc">
      <div className="title-section">
        <div className="title-and-description">
          <div className="title">Expenses</div>
          <div className="description">Track expenses on properties</div>
        </div>
        <div
          className="create-expense-button"
          onClick={() => setShowModal(true)}
        >
          <IoMdAdd />
          Create New
        </div>
      </div>

      <div className="long-rectangle">
        <div className="overlay">
          <div className="left-rectangle">
            <div className="title">All Expenses</div>
            <div className="bottom-section">
              <div className="filters-section">
                <div className="box">
                  <div className="box-title">Start Date</div>

                  <div
                    className="shape"
                    onMouseEnter={() => setHovered(true)}
                    onMouseLeave={() => setHovered(false)}
                    onClick={() => {
                      startDateRef.current.focus();
                      startDateRef.current.showPicker();
                    }}
                  >
                    <input
                      className="date-input full-box"
                      type="date"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                      ref={startDateRef}
                    />
                    <div className="text">{formatDate(startDate)}</div>{" "}
                    {hovered ? (
                      <CalenderIconWhite
                        style={{ height: "15px", width: "15px" }}
                      />
                    ) : (
                      <CalenderIcon style={{ height: "15px", width: "15px" }} />
                    )}
                  </div>
                </div>
                <div className="box">
                  <div className="box-title">End Date</div>
                  <div
                    className="shape"
                    onMouseEnter={() => setHoveredSecond(true)}
                    onMouseLeave={() => setHoveredSecond(false)}
                    onClick={() => {
                      endDateRef.current.focus();
                      endDateRef.current.showPicker();
                    }}
                  >
                    <input
                      className="date-input full-box"
                      type="date"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                      ref={endDateRef}
                    />
                    <div className="text">{formatDate(endDate)}</div>{" "}
                    {hoveredSecond ? (
                      <CalenderIconWhite
                        style={{ height: "15px", width: "15px" }}
                      />
                    ) : (
                      <CalenderIcon style={{ height: "15px", width: "15px" }} />
                    )}
                  </div>
                </div>
                <div className="box">
                  <div className="box-title">Apartment Name</div>
                  <div className="select">
                    <DropdownSelect
                      choices={propertyChoices}
                      defaultChoice={selectedProperty}
                      onSelect={setSelectedProperty}
                      backgroundColor={"#fff"}
                    />
                  </div>
                </div>
                <div className="box">
                  <div className="box-title">Expense Type</div>
                  <div className="select">
                    <DropdownSelect
                      choices={expenseTypeChoices}
                      defaultChoice={selectedExpenseType}
                      onSelect={setSelectedExpenseType}
                      backgroundColor={"#fff"}
                    />
                  </div>
                </div>
              </div>
              <div className="description">
                Apply filters to view specific expenses
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="description" style={{ margin: "20px 0px" }}>
        Expenses History
      </div>
      <TenantTable expenses={expenses} />

     

      {showModal && (
        <CreateExpenseModal
          setShowModal={setShowModal}
          setShowToast={setShowToast}
          setToastType={setToastType}
        />
      )}

      <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
      />
    </div>
  );
};

export default MidSectionExpensesPc;
